import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

interface Props {
  /**
   * Câu của máy chủ khi cổng Studio chặn (409 STUDIO_ROUTE_BLOCKED): Quản lý Studio có thể đã được
   * cấp quyền nhập, nên không dùng câu "chưa được cấp quyền" mặc định.
   */
  message?: string | null;
}

/** MOD chưa được Admin cấp quyền (hoặc vừa bị thu quyền) gõ thẳng /data-import. */
const NoPermission = ({ message }: Props) => {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title={
        message ? 'Bạn không dùng được chức năng Nhập dữ liệu' : 'Bạn chưa được cấp quyền nhập dữ liệu'
      }
      subTitle={
        message ||
        'Hãy liên hệ Admin để được cấp quyền ở Doanh thu → Nhập dữ liệu → Người được nhập.'
      }
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          Về Tổng quan
        </Button>
      }
    />
  );
};

export default NoPermission;
